import { DEFAULT_LOCALE } from 'src/utils/constants';

export const formatPriceString = (price: number, currency: string) => {
  let locale = DEFAULT_LOCALE;

  if ('undefined' !== typeof window && !!window.navigator) {
    locale = window.navigator.language;
  }

  const priceFormatted = new Intl.NumberFormat(locale, { style: 'decimal', minimumFractionDigits: 2 })
    .format(price)
    .replace(',', '.');
  return `${priceFormatted} ${currency.toUpperCase()}`;
};

export const applyModifiers = (
  block: string,
  element?: string,
  modifiers?: string | string[]
): null | string | string[] => {
  if (!modifiers) {
    return null;
  }
  const applyModifier = (modifier: string) => `${block}${element ? `-${element}` : ''}_${modifier}`;
  return Array.isArray(modifiers) ? modifiers.map(applyModifier) : applyModifier(modifiers);
};

export const validateNZBNFormat = (nzbn: string): boolean => {
  // Resource: https://api.business.govt.nz/api/apis/info?name=NZBN&version=v4&provider=mbiecreator#nzbn-format
  const sum: number = nzbn
    .split('', 12)
    .reduce((accumulator, currentValue, index) => accumulator + parseInt(currentValue, 10) * (index % 2 ? 3 : 1), 0);

  const higherTen: number = Math.ceil(sum / 10) * 10;
  const checkDigit: number = parseInt(nzbn.substr(-1), 10);

  return higherTen - sum === checkDigit;
};
